window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default;
require('bootstrap');
// import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;
// import 'popper.js';
// import 'bootstrap';
import mixitup from 'mixitup';
import 'lazysizes';
// import CookieConsentBanner from './CookieConsentBanner';
/*
Teaser Parallax Effect
***************************************************/

function scrollTeaser() {
    //Get the scoll position of the page
    var scrollPos = $(document).scrollTop();

    //Scroll and fade out the banner text
    $('.desktop #teaser #teaserText').css({
        'margin-top': -(scrollPos / 1.4) + 'px',
        opacity: 1 - scrollPos / 400,
    });

    //Scroll and fade out the Stoerer.
    /*
$('#teaser #teaserText #stoerer').css({
		'margin-top' : -(scrollPos*0.5)+"px",
		'opacity' : 1-(scrollPos/400)
	});
*/

    //Scroll the background of the banner
    $('#teaser').css({
        'background-position': 'center ' + -scrollPos / 4 + 'px',
    });
}

/*
Show Item Infos
***************************************************/

function showInfo() {
    $('.item:not(.isActive)')
        .on('mouseenter', function() {
            $(this)
                .find('.info')
                .fadeIn(200);
        })
        .on('mouseleave', function() {
            $(this)
                .find('.info')
                .fadeOut(500);
        });
}

/*
jQ Core
***************************************************/

$(function() {
    // Teaser
    scrollTeaser();

    $(window).on('scroll', function() {
        scrollTeaser();
    });

    // new CookieConsentBanner({
    //     accepted: (data) => { console.log(data);},
    //     declined: (data) => { console.log(data);},
    // });
    // $('.desktop .navbar-collapse .dropdown-toggle').on('click', function() {
    //     if ($('.navbar-collapse').hasClass('in')) {
    //         return;
    //     }

    //     var location = $(this).attr('href');
    //     window.location.href = location;
    //     return false;
    // });

    // Show the Infos
    //	showInfo();

    //	$(".page-id-7 #scrollable").scrollable();

    // Home Text Shortcode readmore button click
    $('.sc-text__readmore').on('click', function(e) {
        let content = $(this)
            .parent('div')
            .next();

        $(this).hide();

        content.css('max-height', 9999);
    });
    // Overlay der Contentbilder
    $('a img.alignleft').on('click', function() {
        var url = $(this)
            .parent()
            .attr('href');
        var alt = $(this).attr('alt');

        $(this).overlay({
            expose: {
                color: '#FFF',
                loadSpeed: 200,
                opacity: 0.8,
                closeOnClick: true,
                zIndex: 1000,
                maskId: 'exposeFoto',
            },
            top: '5%',
            target: '#overlay',
            onBeforeLoad: function() {
                var WRAP = this.getOverlay().find('.contentWrap');

                WRAP.html('<img src="' + url + '" alt="' + alt + '" />');
            },
            onClose: function() {},
            api: true,
            load: true,
        });

        return false;
    });

    // Overlay der Referenzen
    /*
    	$("#scrollReferenzen").scrollable({
    		items: 'ul',
    		size: 6
    	});
    */

    $('#scrollReferenzen ul li a').on('click', function() {
        var src = $(this).attr('href');
        var infos = $(this)
            .parent()
            .find('.referenzInfos')
            .html();

        $(this).overlay({
            expose: {
                color: '#FFF',
                loadSpeed: 200,
                opacity: 0.8,
                closeOnClick: true,
                zIndex: 1000,
                maskId: 'exposeFoto',
            },
            top: '5%',
            target: '#overlay',
            onBeforeLoad: function() {
                var WRAP = this.getOverlay().find('.contentWrap');
                this.getOverlay().addClass('referenzDetail');

                WRAP.html(
                    '<img src="' +
                        src +
                        '" alt="" />' +
                        '<div class="details">' +
                        infos +
                        '<br class="clear" /></div><br class="clear" />'
                );
            },
            onClose: function() {
                this.getOverlay().removeClass('referenzDetail');
            },
            api: true,
            load: true,
        });

        return false;
    });

    // Teaser for Branchen & Kompetenzen
    $('.more a').on('click', function() {
        var more = $(this).parent();
        var loadWrapper = $(this)
            .parents('.item')
            .nextAll('.loadWrapper')
            .first();
        var item = $(this).parents('.item');
        var href = $(this).attr('href');

        // Clear all '.loadWrapper'
        $('.loadWrapper').empty();

        //hide isActive .info
        if (!item.hasClass('isActive')) {
            $('.isActive .info').hide();

            // slide up visible loadWrapper
            if ($('.loadWrapper').is(':visible')) {
                $('.loadWrapper').hide();
            }

            // remove isActive Class
            $('.isActive').removeClass('isActive');

            // Add Class to parent Item
            item.addClass('isActive');

            // show loading
            loadWrapper.addClass('loading');

            //FadeIn
            loadWrapper.fadeIn(200);

            // Load page
            loadWrapper.load(
                href,
                {
                    action: 'load',
                },
                function(data) {
                    loadWrapper.removeClass('loading');
                    //				$("#scrollable").scrollable();
                }
            );
        } else {
            // close Wrapper
            loadWrapper.hide();

            // remove isActive Class
            $('.isActive').removeClass('isActive');
        }

        return false;
    });

    // QS
    // $('#container').mixItUp();
    // var mixer = mixitup('#container');

    // Wir
    $('.desktop #container .mix')
        .on('mouseenter', function() {
            $(this)
                .find('.maInfos')
                .fadeIn(100);
        })
        .on('mouseleave', function() {
            $(this)
                .find('.maInfos')
                .fadeOut(600);
        });
});
